<pdq-card color="white" variant="popover">
  @if (loading) {
    <!-- Empty white space while loading -->
  } @else if (productPromises && productPromises.length > 0) {
    @for (promise of productPromises; track promise.id) {
      <div class="components-list">
        <div class="promise-info">
          <div class="promise-title">{{ promise.internalName || 'Untitled' }}</div>
          <div class="type">
            @if (promise.testMode) {
              <pdq-tag variant="quaternary" mode="rect">Test mode</pdq-tag>
            }
            @if (promise.internalDescription) {
              <span>{{ promise.internalDescription }}</span>
            }
          </div>
        </div>
        <div class="promise-actions">
          <pdq-slide-toggle
            [defaultValue]="promise.isActive"
            (onToggle)="onToggleActive(promise, $event)"></pdq-slide-toggle>
          <pdq-button
            pdqPopover
            variant="ghost"
            icon="dots_menu"
            [popoverTemplate]="actions"
            [forcePosition]="'bottom'"
            [closeOnPopoverClick]="true"
            [closeOnClickOutside]="true">
          </pdq-button>
          <ng-template #actions>
            <pdq-popover-container [loading]="false" [actionList]="true">
              <div class="action-list">
                @for (option of actionOptions; track option) {
                  <pdq-option (onSelect)="onActionOptionSelect(option.value, promise.id, promise.usageToken)">
                    {{ option.label }}
                  </pdq-option>
                }
              </div>
            </pdq-popover-container>
          </ng-template>
        </div>
      </div>
    }
  }
</pdq-card>
